// src/components/common/Toast.tsx
import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

interface ToastItem {
  id: string;
  message: string;
}

const DEFAULT_DURATION = 5500;

let addToastFn: ((message: string, duration: number) => void) | null = null;

/** どこからでも呼べるトースト表示関数（duration: ms、省略時5500ms） */
export const showToast = (message: string, duration = DEFAULT_DURATION) => {
  addToastFn?.(message, duration);
};

const Toast: React.FC = () => {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    addToastFn = (message: string, duration: number) => {
      const id = Date.now().toString();
      setToasts((prev) => [...prev, { id, message }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, duration);
    };
    return () => { addToastFn = null; };
  }, []);

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-2 pointer-events-none">
      <AnimatePresence>
        {toasts.map((toast) => (
          <motion.div
            key={toast.id}
            initial={{ opacity: 0, y: -12, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.95 }}
            transition={{ duration: 0.25 }}
            className="pointer-events-auto flex items-center gap-2 px-5 py-3 bg-gray-900 text-white text-sm font-medium rounded-xl shadow-lg"
          >
            <CheckCircle2 className="w-4.5 h-4.5 text-green-400 flex-shrink-0" />
            {toast.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Toast;
